import VocAudioPlayerRemix from "./src/main"

/* istanbul ignore next */
VocAudioPlayerRemix.install = function (Vue) {
  Vue.component(VocAudioPlayerRemix.name, VocAudioPlayerRemix)
}

export default VocAudioPlayerRemix
